<template>
  <div class="diadin">
    <div class="title">
      <div class="title_1">{{$t('menu.Basicinformation')}}</div>
      <!-- <div>
        <el-button @click="handleEdit">返回</el-button>
      </div> -->
    </div>
    <div class="cont">
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.VehicleName') }}</div>
        <div>{{ filterCarModels(carInfo.mcSeriesModel) }}</div>
      </div>
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.Colour') }}</div>
        <div>{{carInfo.vehicleColor}}</div>
      </div>
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.State') }}</div>
        <div>{{  carInfo.status == 'Registered' ? $t('menu.Registered') : $t('menu.Unregistered')}}</div>
      </div>
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.FrameNumber') }}</div>
        <div>{{carInfo.chassisNumber}}</div>
      </div>
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.EngineNumber') }}</div>
        <div>{{carInfo.engineNumber}}</div>
      </div>
    
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.zcmxlsh') }}</div>
        <div>{{carInfo.retailerName}}</div>
      </div>
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.DeliveryDate') }}</div>
        <div>{{(carInfo.entryDate != null && carInfo.entryDate !='') ?carInfo.entryDate.split(' ')[0] : carInfo.entryDate }}</div>
      </div>
       
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.zcmxzbdqsj') }}</div>
        <div>{{(carInfo.warrantyExpiry != null && carInfo.warrantyExpiry !='') ?carInfo.warrantyExpiry.split(' ')[0] : carInfo.warrantyExpiry }}</div>
      </div> 
       <div class="contbox" v-if="carInfo.invoiceUrl!==null">
        <div class="conttitle">{{ $t('menu.fapiao') }}</div>
        <!-- <div>{{ $t('menu.Download') }}</div> -->
         <el-button type="text" size="mini" >
              <a style="text-decoration:none;color: #66b1ff;" :href="ncodeUrlPath(carInfo.invoiceUrl)" >{{ $t('menu.Download') }}</a>
          </el-button>
      </div> 
    </div>
    <div class="title" style="margin-bottom: 20px;justify-content: left;">
      <div class="title_1" style="cursor: pointer; margin-right: 25px;" :class="(action == $t('menu.CustomerInformation') && type != 1) ? 'actio' : ''" @click="act($t('menu.CustomerInformation'))">
        {{$t('menu.CustomerInformation') }}
      </div>
       <div style="cursor: pointer;text-align: center; margin-right: 25px;" :class="action == $t('menu.weibaojil') ? 'actio' : ''" @click="act($t('menu.weibaojil'))" v-if="type == 2">
        {{ $t('menu.weibaojil') }}
      </div>
      <div style="cursor: pointer;text-align: center; margin-right: 25px;" :class="action == $t('menu.ClaimRecord') ? 'actio' : ''" @click="act($t('menu.ClaimRecord'))" v-if="type == 2">
        {{ $t('menu.ClaimRecord') }}
      </div>
      <div style="cursor: pointer;text-align: center; margin-right: 25px;" :class="action == $t('menu.OperationRecord') ? 'actio' : ''" @click="act($t('menu.OperationRecord'))" v-if="type == 2">
        {{ $t('menu.OperationRecord') }}
      </div>
    
    </div>
    <div v-if="action == $t('menu.CustomerInformation')" class="customerINfo">
      
      <!-- <div class="boxOne" v-if="tup==1">
        <div class="label"><span style="color: red;" v-if="type==1 || type == 3">*</span> {{$t('menu.zcmxlsh')}}</div>
        <el-select v-model="carInfo.retailerId" :placeholder="$t('menu.zcmxlsh')" v-if="type==1 || type == 3" @change="cbcac">
          <el-option :key="index" :label="item.dealerName" :value="item.id" v-for="(item,index) in lslis"></el-option>
        </el-select>
    
        <div v-if="type==2">{{carInfo.retailerName}}</div>
      </div> -->









      <!-- 客户的信息 -->
      <!-- <div class="boxOne">
        <div class="label"><span style="color: red;" v-if="type==1 || type == 3">*</span> {{$t('menu.CustomerName')}}</div>
        <el-input v-model="carInfo.customerName" :placeholder="$t('menu.Enter')" v-if="type==1 || type == 3"></el-input>
        <div v-if="type==2">{{carInfo.customerName}}</div>
      </div> -->
      <div class="boxOne">
        <div class="label"><span style="color: red;" v-if="type==1 || type == 3">*</span> {{ $t('menu.CustomerType') }}</div>
        <el-select v-model="carInfo.customerType" :placeholder="$t('menu.CustomerType')" v-if="type==1 || type == 3">
          <el-option :label="item.dictLabel" :value="item.dictValue" v-for="(item,index) in titleList" :key="index"></el-option>
        </el-select>
        <div v-if="type==2">{{ checkcurtype(carInfo.customerType)}}</div>
      </div>
      <div class="boxOne">
        <div class="label"><span style="color: red;" v-if="type==1 || type == 3">*</span>  {{ $t('menu.SaleDate') }}</div>
        <el-date-picker type="date"   :picker-options="pickerOptions" :placeholder="$t('menu.Expected')" v-model="carInfo.salesDate" value-format="yyyy-MM-dd" style="width: 91%" v-if="type==1 || type == 3" ></el-date-picker>
        <div v-if="type==2">{{carInfo.salesDate}}</div>
      </div>
      <!-- <div class="boxOne">
        <div class="label">  {{ $t('menu.licensePlateNumber') }}</div>
        <el-input v-model="carInfo.licensePlate" :placeholder="$t('menu.Enter')" v-if="type==1 || type == 3"></el-input>
        <div v-if="type==2">{{carInfo.licensePlate}}</div>
      </div>
      <div class="boxOne">
        <div class="label">  {{ $t('menu.contactNumber') }}</div>
        <el-input v-model="carInfo.customerPhone" :placeholder="$t('menu.Enter')" v-if="type==1 || type == 3"></el-input>
        <div v-if="type==2">{{carInfo.customerPhone}}</div>
      </div>
      <div class="boxOne">
        <div class="label">  {{ $t('menu.EmailAddress') }}</div>
        <el-input v-model="carInfo.customerEmail" :placeholder="$t('menu.Enter')" v-if="type==1 || type == 3"></el-input>
        <div v-if="type==2">{{carInfo.customerEmail}}</div>
      </div>
      <div class="boxTwo">
        <div class="label">{{ $t('menu.Address') }}</div>
        <el-input v-model="carInfo.customerAddress" :placeholder="$t('menu.Enter')" v-if="type==1 || type == 3"></el-input>
        <div v-if="type==2">{{carInfo.customerAddress}}</div>
      </div> -->
      <div class="boxTwo">
        <div class="label">{{ $t('menu.PictureMaterials') }}</div>
        <el-upload action="#" class="upload-demo" :http-request="uploadFile" :show-file-list="false" v-if="type==1 || type == 3">
          <el-button size="small" plain>{{$t('menu.Uploadfiles')}}</el-button>
        </el-upload>
        <div class="demo-image__preview">
          <div class="im" v-for="(item,index) in imgsrcList" :key="index">
            <el-image @click="filedialogVisiblea(item)" :src="item" :preview-src-list="imgsrcList" class="imgBox"></el-image> 
            <i class="el-icon-circle-close iconB" @click="deleteImg(item)" v-if="type !=2"></i>
          </div>
        </div>
      </div>
    </div>
        <div v-if="action == $t('menu.weibaojil')">
      <el-table :data="wblist" style="width: 100%" stripe border highlight-current-row>
        <el-table-column prop="orderNumber" :label="$t('menu.wbddh')" width="200"></el-table-column>
         <el-table-column prop="serviceType" :label="$t('menu.cgwdlx')">
            <template slot-scope="sopce">
              <div v-if="sopce.row.serviceType=='wx'">{{$t('menu.weix')}}</div>
            <div v-if="sopce.row.serviceType=='by'">{{$t('menu.baoyang')}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="mileage" :label="$t('menu.Mileage2')" width="180"> </el-table-column>
          <el-table-column prop="dealerName" :label="$t('menu.zcmxlsh')" > </el-table-column>
          <el-table-column prop="finishTime" :label="$t('menu.weibaoshijian')"> </el-table-column>
         
      </el-table>
    </div>
    <div v-if="action == $t('menu.ClaimRecord')">
      <el-table :data="splist" style="width: 100%" stripe border highlight-current-row>
        <el-table-column prop="claimNumber" :label="$t('menu.ClaimNumber')" width="180"></el-table-column>
          <el-table-column prop="mcSeriesModelId" :label="$t('menu.Vehicle')" width="180">
             <template slot-scope="sopce">
              <div>{{ filterCarModels(sopce.row.mcSeriesModelId) }}</div>
            
            </template>
            
          </el-table-column>
          <el-table-column prop="claimType" :label="$t('menu.ClaimType')">
            <template slot-scope="sopce">
              <div>{{ sxsptype(sopce.row.claimType) }}</div>
            
            </template>
          </el-table-column>
          <el-table-column prop="mileage" :label="$t('menu.Mileage2')" width="130"></el-table-column>
          <!-- <el-table-column prop="zt" :label="$t('menu.Currency')" width="150">
          <template slot-scope="scope">
            {{ scope.row.zt | sellstatus }}
          </template>
        </el-table-column>
        <el-table-column prop="rk" :label="$t('menu.ClaimAmount')" width="150"></el-table-column> -->
        <el-table-column prop="createdTime" :label="$t('menu.ApplicationTime')"></el-table-column>
      </el-table>
    </div>
    <div v-if="action == $t('menu.OperationRecord')">
      <el-table :data="carInfo.logs" style="width: 100%" stripe border highlight-current-row>
        <el-table-column prop="actionTime" :label="$t('menu.Timecaozuo')" width="180"></el-table-column>
        <el-table-column prop="actionUserName" :label="$t('menu.Operator')" width="180"> </el-table-column>
        <el-table-column prop="actionEvent" :label="$t('menu.OperationContent')"></el-table-column>
        <el-table-column prop="remark" :label="$t('menu.Remarks')" width="130"></el-table-column>
      </el-table>
    </div>
    <div>
      <el-button v-if="type==2" type="primary" @click="edit()">{{ $t('menu.Modify') }}</el-button>
      <el-button type="primary" @click="submitForm()" v-if="type==1">{{ $t('menu.Save') }}</el-button>
      <el-button type="primary" @click="editForm()" v-if="type==3">{{ $t('menu.Save') }}</el-button>
      <el-button @click="resetForm()" v-if="type==1 || type == 3">{{ $t('menu.Cancel') }}</el-button>
    </div>
     <!-- 文件预览 -->
    <el-dialog :visible.sync="filedialogVisible" :title="srtitle" v-if="filedialogVisible"  width="70%" style="">
    
       <yl v-if="typ == 'pdf'" :url="filedialogImageUrl" :typ="'pdf'"></yl>
      <!-- <iframe v-if="typ == 'pdf'" :src="videoUrl"  width="100%" height="800px" /> -->
       <!-- <iframe v-if="typ == 'pdf'"  frameborder="0" :src="videoUrl"  width="100%" height="800px" /> -->
      <yl v-if="typ == 'xlsx'" :url="filedialogImageUrl" :typ="'xlsx'"></yl>
      <yl v-if="typ == 'docx'" :url="filedialogImageUrl" :typ="'docx'"></yl>
      <yl v-if="typ == 'excel'" :url="filedialogImageUrl" :typ="'excel'"></yl>
      <img style="width: 100%;" v-if="typ == 'png' || typ == 'jpg' || typ == 'jepg'" :src="filedialogImageUrl" alt="">
      <iframe v-if="typ !== 'png' && typ !== 'jpg' && typ !== 'jepg' && typ !== 'mp4' && typ !== 'txt' && typ !== 'pdf'&& typ !== 'xlsx'&& typ !== 'docx'&& typ !== 'excel'"
        :src='filedialogImageUrl' style="width: 100%; height: 70vh" frame />
    </el-dialog>
  </div>
</template>
    
<script>
import { mcVehicleOfDealerInfo,retailerlist,upload,moOfDealerlist,listMcSeriesModels,vincont,changemcVehicleOfDealer,aaddmcVehicleOfDealer,querytype } from "../../api/api";

import yl from '../../components/yl' //发票
export default {
   components: {
    yl
   
  },
  data() {
    return {
      action: this.$t('menu.CustomerInformation'),
      type:1,  //1-注册  2-展示  3-修改
      mation:[],
      id:null,
      input:'',
      carInfo:{},
      imgsrcList: [],
      cartypelist:[],
      iszh:sessionStorage.getItem('i18n'),
      titleList:[],
      splist:[],
      cptypelist:[],
      wblist:[],
      lslis:[],
      tup:2,
      filedialogVisible:false,
      srtitle:'',
      filedialogImageUrl:'',
      typ:'',
      pickerOptions: {
     disabledDate(time) {
    // 禁用今天之后的日期，今天可选
    const today = new Date()
    today.setHours(23, 59, 59, 999)  // 设为今天23:59:59
    return time.getTime() > today.getTime()
  }
    }
    };
  },
  mounted() {
    this.getQuerytype()
    this.id=this.$route.query.id
    this.type = this.$route.query.index
    this.tup=sessionStorage.getItem('platform')
    this.mcVehicleOfDealerInfo()
    this.listMcSeriesModel()
    this.lsslist()
  
  },
  methods: {
 filedialogVisiblea(str){
      console.log(str);
      this.srtitle=str.name
      let b = str.name.substring(str.name.lastIndexOf(".") + 1, str.name.length);

      // this.aurl='https://view.officeapps.live.com/op/view.aspx?src=https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath
      this.filedialogImageUrl = str.url
      this.typ=b



 
      this.filedialogVisible = true
    },
      ncodeUrlPath(url) {
  // 找到最后一个 '/' 的位置
  const lastSlashIndex = url.lastIndexOf('/');

  // 如果没有找到 '/', 直接返回原字符串
  if (lastSlashIndex === -1) {
    return url;
  }

  // 提取最后一个 '/' 之前的部分（包括 '/'）
  const prefix = url.substring(0, lastSlashIndex + 1);

  // 提取最后一个 '/' 之后的部分（文件名）
  const fileName = url.substring(lastSlashIndex + 1);

  // 对文件名部分进行 encodeURIComponent 转码
  const encodedFileName = encodeURIComponent(fileName);

  // 拼接返回
  return prefix + encodedFileName;
},
    cbcac(e){
      console.log(e);
      this.lslis.forEach(z=>{
        if(z.id==e){
          this.carInfo.retailerName=z.dealerName
        }
      })
    },
     async lsslist(){
      
        let param = new URLSearchParams()
      const { data: res } = await retailerlist(param, 1,1000)
      console.log(res.rows);
    this.lslis=res.rows
      
    },
    //获取车辆详细信息
    mcVehicleOfDealerInfo(){
      mcVehicleOfDealerInfo(this.id).then(res=>{
         console.log(123,res);
        
        if(res.data.code==500){
            this.$message.error(res.data.msg)
        }
        this.carInfo = res.data.data
        this.cvin( this.carInfo.chassisNumber)
        this.mowb()
        // this.carInfo.salesDate = new Date().getFullYear() + '-' + String(new Date().getMonth() + 1).padStart(2, '0') + '-' +  String(new Date().getDate()).padStart(2, '0');
        if( this.carInfo.customerMaterials!='') this.imgsrcList = this.carInfo.customerMaterials.split(',')
       
      })
    },
    cvin(e){
     let data ={}
      vincont(data,e,1,100).then(res=>{
      
        
       this.splist=res.data.data.list
       this.cptype()
      })
    },
    mowb(){
       let params = 'vin='+this.carInfo.chassisNumber
      moOfDealerlist(params).then(res=>{
        console.log(12111111111113,res.data);
        
       this.wblist=res.data.rows
      
      })
    },
    
    sxsptype(e){
      let a =''
        this.cptypelist.forEach(z=>{
          if(z.dictValue==e){
              if (this.iszh !== 'zh') {
             z.dictLabel = z.dictLabelEn
            }
            a=z.dictLabel
            
          }
        })
        return a
    },
      //索赔类型
    async cptype () {
      
      const params = new URLSearchParams()
      querytype( params, 't_co_claim_type').then(r => {
        console.log(r);
        this.cptypelist = r.data.data;
       
      })
    },
    //获取车型
    async listMcSeriesModel () {
      // let param = new URLSearchParams();
      // const { data: res } = await listMcSeriesModels(param);
      // this.cartypelist = res.data;
      const params = new URLSearchParams()
      querytype( params, 't_mc_series_model').then(r => {
        console.log(r);
        this.cartypelist = r.data.data;
        // if (r.data.code == 200) {
        //   r.data.data.forEach(i => {
        //     if (this.iszh !== 'zh') {
        //       i.dictLabel = i.dictLabelEn
        //     }
        //     this.titleList.push(i)
        //   })
        // }
      })
    },
    filterCarModels(m){
      if(this.cartypelist.some(e=>e.dictValue == m)){
        return this.cartypelist.filter(e=>e.dictValue == m)[0].dictLabel
      } else {
        return m
      }
    }, 
    submitForm() {
      this.carInfo.status = 'Registered'
      let a = ''
      this.imgsrcList.forEach(e=>{
        if(a == ''){
          a = a + e
        } else {
          a = a + ',' + e
        }
      })
     
      this.carInfo.customerMaterials = a 
      let data= this.carInfo
      data.salesDate=this.carInfo.salesDate+' 00:00:00'
      data.status='Registered'
      changemcVehicleOfDealer(data).then(res=>{
        if(res.data.code == 200){
          this.$message.success(res.data.msg)
          this.$router.push('/sell')
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    editForm(){
      let a = ''
      this.imgsrcList.forEach(e=>{
        if(a == ''){
          a = a + e
        } else {
          a = a + ',' + e
        }
      })
      this.carInfo.customerMaterials = a 
      
      let data= this.carInfo
      if(data.salesDate.length<11){
         data.salesDate=this.carInfo.salesDate+' 00:00:00'
       }
      changemcVehicleOfDealer(data).then(res=>{
        if(res.data.code == 200){
          this.$message.success(res.data.msg)
          this.$router.push('/sell')
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    edit(){
      this.type = 3
    },
    resetForm() {
      this.$router.push('/sell')
    },
    act(e){
      this.action = e
    },
    uploadFile(file){
      let formdata = new FormData()
      formdata.append('file',file.file)
      formdata.append('category',file.file.type)
      upload(formdata).then(res=>{
        if(res.data.code == '200'){
          this.$message.success('上传成功')
          this.imgsrcList.push(res.data.data)
        } else {
          this.$message.error('上传失败')
        }
      })
    },
    deleteImg(e){
      this.imgsrcList = this.imgsrcList.filter(m=>m != e)
    },
    handleEdit(index, row) {
      this.$router.push({
        path: "/sell",
        query: {
        },
      });
    },
    getQuerytype () {
      const params = new URLSearchParams()
      querytype( params, 't_mc_vehicle_customer_type').then(r => {
        if (r.data.code == 200) {
          r.data.data.forEach(i => {
            if (this.iszh !== 'zh') {
              i.dictLabel = i.dictLabelEn
            }
            this.titleList.push(i)
          })
        }
      })
    },
    checkcurtype(e){
      return this.titleList.filter(m=>m.dictValue == e).length> 0 ? this.titleList.filter(m=>m.dictValue == e)[0].dictLabel : e
    },
  },
};
</script>
    
<style lang="less" scoped>
.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  .title {
    width: 100%;
    border-bottom: 1px solid #f2f2f2;
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title_1 {
      padding-left: 15px;
      border-left: 5px solid #409eff;
    }
  }
  .cont {
    display: flex;
    flex-wrap: wrap;
    padding: 30px 10px;
    .contbox {
      width: 30%;
      text-align: left;
      margin: 10px 0;
      .conttitle {
        width: 180px;
        padding: 15px 0;
      }
    }
  }
  .customerINfo{
    width: 100%;
    padding: 0 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .boxOne{
      width: 30%;
      margin: 10px 0;
      .label{
        padding-bottom: 10px;
      }
    }
    .boxTwo{
      width: 100%;
      margin: 10px 0;
      .label{
        padding-bottom: 10px;
      }
      .demo-image__preview{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .im{
          position: relative;
          .imgBox{
            margin: 10px;
            width: 200px;
            height: 100px;
          }
          .iconB{
            position: absolute;
            color: red;
            top: 0px;
            right: 0px;
            cursor: pointer;
            font-size: 24px;
          }
        }
        
      }
    }
  }
}
/deep/.el-form-item__content {
  width: 100%;
}
/deep/.el-select {
  width: 95%;
}
/deep/.el-table th.is-leaf{
    text-align: center;
    background-color: #d7d7d7;
}
.actio{
  color: #409eff;
}
</style>